import { Button, Card, Select, CloseIcon } from '@instabox/consumer-web-ui'
import { ForwardedRef, forwardRef } from 'react'
import { AnimatePresence, HTMLMotionProps, motion } from 'framer-motion'
import { FormattedMessage } from 'react-intl'

import styles from './faqFilter.module.scss'

export interface Filter {
  label: string
  id: string
  value: string
  options: {
    id: string
    label: string
  }[]
  onChange: (id: string, value: string) => void
}

export interface FilterActions {
  onFilterApply: () => void
  onFilterReset: () => void
}

export interface FAQFilterProps extends FilterActions {
  isOpen: boolean
  filters: Filter[]
}

const FAQFilter = (
  { isOpen, filters, onFilterApply, onFilterReset }: FAQFilterProps,
  ref: ForwardedRef<HTMLDivElement>,
) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div {...faqFilterAnimation}>
          <Card size="sm" variant="info" className={styles.filterContainer} ref={ref}>
            {filters.map(filter => (
              <div key={filter.id} className={styles.selectBox}>
                <Select
                  label={filter.label}
                  value={filter.value}
                  size="large"
                  onChange={filter.onChange}>
                  {filter.options.map(option => (
                    <option key={option.id} id={option.id} value={option.id}>
                      {option.label}
                    </option>
                  ))}
                </Select>
              </div>
            ))}
            <div className={styles.filterActions}>
              <div className="row">
                <div className="col-6">
                  <Button fluid variant="secondary" icon={<CloseIcon />} onClick={onFilterReset}>
                    <FormattedMessage id="general.reset" />
                  </Button>
                </div>
                <div className="col-6">
                  <Button fluid onClick={onFilterApply}>
                    <FormattedMessage id="general.apply" />
                  </Button>
                </div>
              </div>
            </div>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default forwardRef(FAQFilter)

const faqFilterAnimation: HTMLMotionProps<'div'> = {
  initial: 'hidden',
  animate: 'visible',
  exit: 'hidden',
  transition: {
    duration: 0.3,
    ease: 'easeInOut',
  },
  variants: {
    hidden: { y: '-10px', opacity: 0 },
    visible: { y: 'calc(100% + var(--gap-sm))', opacity: 1 },
  },
}
